var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "labels-wrap" }, [
    _vm.is_load
      ? _c(
          "div",
          { staticClass: "labels-loading" },
          [_c("Info_field", { attrs: { title: "Loading labels..." } })],
          1
        )
      : _c("div", [
          _vm.tabs.length > 0
            ? _c(
                "div",
                { staticClass: "labels-tabs" },
                _vm._l(_vm.tabs, function (tab) {
                  return _c(
                    "button",
                    {
                      key: tab.key,
                      staticClass: "labels-tab",
                      class: { active: _vm.activeTab === tab.key },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = tab.key
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(tab.title) +
                          "\n                "
                      ),
                      _c("span", { staticClass: "labels-tab-count" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(tab.selected) +
                            "/" +
                            _vm._s(tab.count) +
                            "\n                "
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "labels-list" },
            [
              _vm._l(_vm.filteredLabels, function (label) {
                return _c(
                  "button",
                  {
                    key: label,
                    staticClass: "label-row",
                    class: { "is-active": _vm.isActive(label) },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleLabel(label)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "label-left" }, [
                      _c("div", { staticClass: "label-title" }, [
                        _vm._v(_vm._s(_vm.formatLabel(label))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "label-code" }, [
                        _vm._v(_vm._s(label)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "label-right",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("input", {
                          staticClass: "label-check d-none",
                          attrs: { type: "checkbox", readonly: "" },
                          domProps: { checked: _vm.isActive(label) },
                        }),
                      ]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.filteredLabels.length === 0
                ? _c("div", { staticClass: "labels-empty" }, [
                    _vm._v(
                      "\n                Нет лейблов в этой группе\n            "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }